/* Buzzwoo · Ideenverlag · Ratgeber-Übersicht · Kategorie-Filter
 *
 * Tiny custom element (Idiom: bw-iv-themenwelt-vergleich.js).
 * Chips toggeln Karten via data-bw-kategorie; ?kategorie={handle}
 * wird via history.replaceState gesynct (Deep-Links). Ohne JS
 * bleiben alle Karten sichtbar — Progressive Enhancement.
 * Filter wirkt pro Paginierungs-Seite (dokumentierte Grenze).
 */
class BwIvRatgeberFilter extends HTMLElement {
  connectedCallback() {
    this.chips = Array.from(this.querySelectorAll('.bw-iv-ratgeber-grid__chip'));
    this.cards = Array.from(this.querySelectorAll('.bw-iv-ratgeber-card'));
    this.noResults = this.querySelector('.bw-iv-ratgeber-grid__no-results');
    if (!this.chips.length || !this.cards.length) return;

    this.chips.forEach((chip) => {
      chip.addEventListener('click', () => this.apply(chip.dataset.bwKategorie || ''));
    });

    const initial = new URLSearchParams(window.location.search).get('kategorie');
    if (initial) this.apply(initial);
  }

  apply(handle) {
    let shown = 0;
    this.cards.forEach((card) => {
      const match = !handle || card.dataset.bwKategorie === handle;
      card.hidden = !match;
      if (match) shown += 1;
    });

    this.chips.forEach((chip) => {
      const isActive = (chip.dataset.bwKategorie || '') === handle;
      chip.classList.toggle('is-active', isActive);
      chip.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (this.noResults) this.noResults.hidden = shown > 0;

    const url = new URL(window.location.href);
    if (handle) {
      url.searchParams.set('kategorie', handle);
    } else {
      url.searchParams.delete('kategorie');
    }
    window.history.replaceState({}, '', url);
  }
}

if (!customElements.get('bw-iv-ratgeber-filter')) {
  customElements.define('bw-iv-ratgeber-filter', BwIvRatgeberFilter);
}
